import { all, takeLatest } from 'redux-saga/effects';
import { toast } from 'sonner';
import { t } from 'copy/t';
import {
  DOWNLOAD_LEADS_REQUEST,
  DOWNLOAD_LEADS_SUCCESS,
  DOWNLOAD_LEADS_FAIL,
  FETCH_LEADS_REQUEST,
} from './constants';
import {
  fetchLeadSuccess,
  fetchLeadFail,
  downLoadLeadSuccess,
  downLoadLeadFail,
} from './actions';
import { authedApiSaga } from 'sagas';
import { getLeads, downloadLeads } from 'utils/api/leads';

const getFetchParams = (params) => {
  return params
    ? `?${Object.keys(params).map(k => params[k] ? `${k}=${params[k]}` : null).filter(x => x).join('&')}`
    : '';
}

export function* fetchLeadsFlow({ params }) {
  yield* authedApiSaga(token => getLeads(token, getFetchParams(params)), [], fetchLeadSuccess, fetchLeadFail);
}

export function* downloadLeadsFlow({ params }) {
  yield* authedApiSaga(token => downloadLeads(token, getFetchParams(params)), [], downLoadLeadSuccess, downLoadLeadFail);
}

export function* downloadLeadsSuccessFlow() {
  toast.success(t('toast.leads.csvExportStarted'));
}

export function* downloadLeadsFailureFlow() {
  toast.error(t('toast.leads.csvExportFailed'));
}

export default function* watchChannels() {
  yield all([
    takeLatest(FETCH_LEADS_REQUEST, fetchLeadsFlow),
    takeLatest(DOWNLOAD_LEADS_REQUEST, downloadLeadsFlow),
    takeLatest(DOWNLOAD_LEADS_SUCCESS, downloadLeadsSuccessFlow),
    takeLatest(DOWNLOAD_LEADS_FAIL, downloadLeadsFailureFlow),
  ]);
}
